import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=a273fad0&scoped=true"
import script from "./Node.vue?vue&type=script&lang=js"
export * from "./Node.vue?vue&type=script&lang=js"
import style0 from "./Node.vue?vue&type=style&index=0&id=a273fad0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a273fad0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a273fad0')) {
      api.createRecord('a273fad0', component.options)
    } else {
      api.reload('a273fad0', component.options)
    }
    module.hot.accept("./Node.vue?vue&type=template&id=a273fad0&scoped=true", function () {
      api.rerender('a273fad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/process/nodes/Node.vue"
export default component.exports